<div class="storm-details-container">
  <div class="panel-title">
    Storm {{ storm.name }}
  </div>
  <div class="panel-content">
    <div>
      Start: {{ storm.startTime | date:'MMM d h:mma' }}
    </div>
    <div>
      End: {{ storm.endTime | date:'MMM d h:mma' }}
    </div>

    @if (stormStats.distanceDriven > 0) {
      <div>
        {{ stormStats.distanceDriven | distance:configuration.useMetricSystem:false }} Total {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }}
      </div>
    }
    @if (stormStats.distancePlowed > 0) {
      <div>
        {{ stormStats.distancePlowed | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Plowed
      </div>
    }
    @if (stormStats.distanceSpreadGranular > 0) {
      <div>
        {{ stormStats.distanceSpreadGranular | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Granular Spread
      </div>
    }
    @if (stormStats.distanceSpreadLiquid > 0) {
      <div>
        {{ stormStats.distanceSpreadLiquid | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Liquid Spread
      </div>
    }
    @if (stormStats.materialUsedGranular > 0) {
      <div>
        {{ stormStats.materialUsedGranular | weight:configuration.useMetricSystem }} Granular
      </div>
    }
    @if (stormStats.materialUsedLiquid > 0) {
      <div>
        {{ stormStats.materialUsedLiquid | volume:configuration.useMetricSystem }} Liquid
      </div>
    }
    @if (stormStats.distanceMowed > 0) {
      <div>
        {{ stormStats.distanceMowed | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Mowed
      </div>
    }
    @if (stormStats.distanceSwept > 0) {
      <div>
        {{ stormStats.distanceSwept | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Swept
      </div>
    }
  </div>

  <div class="flex-row align-items-center gap-4">
    <div>Shifts</div>

    <button mat-icon-button
            (click)="toggleShifts()"
            [attr.aria-label]="shiftsCollapsed? 'expand shifts' : 'collapse shifts'"
    >
      @if (shiftsCollapsed) {
        <mat-icon class="tree-level-button">arrow_right</mat-icon>
      } @else {
        <mat-icon class="tree-level-button">arrow_drop_down</mat-icon> <!-- expanded -->
      }
    </button>
  </div>
  @if (!shiftsCollapsed) {
    <div>
      @for (shift of shiftMenuItems; track shift.id) {
        <app-action-menu-item [input]="shift"></app-action-menu-item>
      }
    </div>
  }

  <div class="flex-row align-items-center gap-4">
    <div>Observations</div>

    <button mat-icon-button
            (click)="toggleObservations()"
            [attr.aria-label]="observationsCollapsed? 'expand observations' : 'collapse observations'"
    >
      @if (observationsCollapsed) {
        <mat-icon class="tree-level-button">arrow_right</mat-icon>
      } @else {
        <mat-icon class="tree-level-button">arrow_drop_down</mat-icon> <!-- expanded -->
      }
    </button>
  </div>
  @if (!observationsCollapsed) {
    <div>
      @if (observations && observations.length > 0 && observationMenuItems) {
        @for (item of observationMenuItems; track item.id) {
          <app-action-menu-item [input]="item" #itemRef [id]="'obs-'+item.id"></app-action-menu-item>
        }
      } @else {
        <span>None</span>
      }
    </div>
  }
</div>
